/*
 we should use dashes instead of spaces if the search string is not a part of query params
 otherwise if it's a part of query params, then we should use pluses instead of spaces
 */
export function normalizeSearchString(searchString, useDashesInsteadOfSpaces) {
  const sp = new URLSearchParams();
  sp.append('q', useDashesInsteadOfSpaces ? searchString.replace(/\s/g, '-') : searchString);
  return sp.toString().split('=')[1];
}
